export default `
mutation CreateUser($serviceProviderId: String!, $email: String!, $displayName: String!, $role: KirsRoles!, $officerLevel: OfficerLevel){
  createServiceProviderUser(serviceProviderId: $serviceProviderId, email: $email, displayName: $displayName, role: $role, officerLevel: $officerLevel) {
    coordinates {
      lat
      lng
    }
    officerLevel
    userId
    updatedAt
    displayName
    serviceProviderId
    status
    role
    respondingTo {
      instanceId
      propertyId
    }
    isDeleted
    inRange
  }
}
`;